module.exports = __webpack_public_path__ + "img/avatar.af06fd49.png";